module.exports = __webpack_public_path__ + "static/media/user-flow.a7ffea0a.png";